import React, { useEffect, useRef } from 'react';
import "./Banner.scss"
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import bannerImage from "../../Assets/images/home-banner.png";
import ServiceCards from '../ServiceCards/ServiceCards';
import StandardsSection from '../StandardsSection/StandardsSection';
import LoadVisibility from '../LoadVisibility/LoadVisibility';
import TransparencyGuarantee from '../TransparencyGuarantee/TransparencyGuarantee';
import AppPromo from '../AppPromo/AppPromo';
import CallToAction from '../CallToAction/CallToAction';
import TruckImageSection from '../TruckImageSection/TruckImageSection';

const bannerData = {
  badge: "Now Serving the GTA",
  headingLine1: "Ontario\u2019s Digital",
  headingLine2: "Marketplace for",
  headingHighlight: "Heavy Hauling",
  description:
    "Connecting WSIB-verified carriers with Ontario contractors - powered by a transparent 5% flat fee.",
  stats: [
    { value: "5%", label: "FLAT FEE" },
    { value: "WSIB", label: "VERIFIED" },
    { value: "GTA", label: "COVERAGE" },
  ],
};

const Banner = ({ onSignUpClick }) => {
  const bannerRef = useAnimateOnScroll();
  const mainRef = useRef(null);
  const ctaRef = useRef(null);

  useEffect(() => {
    const main = mainRef.current;
    const cta = ctaRef.current;
    if (!main || !cta) return;

    const updateCtaHeight = () => {
      main.style.setProperty('--cta-h', `${cta.offsetHeight}px`);
    };

    updateCtaHeight();
    const observer = new ResizeObserver(updateCtaHeight);
    observer.observe(cta);
    return () => observer.disconnect();
  }, []);

  return (
  <main ref={mainRef} className="home-main">
    <section className="main-wraper banner-cvr">
      <img className="bg-image" src={bannerImage} alt="Background" />
      <div className="banner-content">
        <div className="container">
        <div ref={bannerRef} className="banner-inner left-in">
          <span className="banner-badge">{bannerData.badge}</span>
          <h1>
            {bannerData.headingLine1}
            <br />
            {bannerData.headingLine2}
            <br />
            <span className="text-highlight">{bannerData.headingHighlight}</span>
          </h1>
          <p>{bannerData.description}</p>
          <div className="banner-stats">
            {bannerData.stats.map((stat, index) => (
              <React.Fragment key={index}>
                {index > 0 && <div className="stat-divider" />}
                <div className="banner-stat-item">
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
        </div>
      </div>
    </section>
    <ServiceCards onSignUpClick={onSignUpClick} />
    <StandardsSection />
    <LoadVisibility />
    <TransparencyGuarantee />
    <AppPromo />
    <div className="cta-straddle-wrapper">
      <CallToAction onSignUpClick={onSignUpClick} ctaRef={ctaRef} />
      <TruckImageSection />
    </div>
  </main>
  );
};

export default Banner;
